import { migration as initial } from "./001_initial";
import { migration as fbMessengerSeed } from "./002_facebook_messenger_seed";
import { migration as lineOaSeed } from "./003_line_oa_seed";
import { migration as instagramDmSeed } from "./004_instagram_dm_seed";
import { migration as googleCalendarSeed } from "./005_google_calendar_seed";
import { migration as gmailSeed } from "./006_gmail_seed";
import { migration as shopeeSeed } from "./007_shopee_seed";
import { migration as addCapabilityPrimary } from "./008_add_capability_primary";
import { migration as addDefaultAiAgent } from "./009_add_default_ai_agent";
import { migration as fbMessengerFlb } from "./010_facebook_messenger_flb";
import { migration as fbPageSeed } from "./011_facebook_page_seed";
import { migration as fbPageFullScope } from "./012_facebook_page_full_scope";
import { migration as fbPageReadInsightsScope } from "./013_facebook_page_read_insights_scope";
export const migrations = [
  initial,
  fbMessengerSeed,
  lineOaSeed,
  instagramDmSeed,
  googleCalendarSeed,
  gmailSeed,
  shopeeSeed,
  addCapabilityPrimary,
  addDefaultAiAgent,
  fbMessengerFlb,
  fbPageSeed,
  fbPageFullScope,
  fbPageReadInsightsScope,
];
